exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".os_t__item[data-v-cac6c732]{margin:0 5px 0 0}.student-menu[data-v-cac6c732]{margin-top:20px;font-size:13px}.feedback[data-v-cac6c732]{margin-left:10px}.student-name[data-v-cac6c732]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;justify-content:space-between}.header-menu__btn[data-v-cac6c732]{font-size:12px}", ""]);

// exports
